/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useLocation, useMedia } from '@api/hooks';
import { InfoItem } from '@molecules';
import { getImage } from '@utils/media';

const LocationItem = ({ location, onClick }) => {
  const { media } = useMedia(getImage(location, 'image'));
  const { location: _location } = useLocation({ id: location.locationId });

  return (
    <InfoItem onClick={onClick} image={media.src} description={_location.name}>
      {location.headline || location.location.name}
    </InfoItem>
  );
};

export default LocationItem;
